import { Box, Skeleton, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { HandleErrorAndLoading } from "@common/HandleErrorAndLoading/HandleErrorAndLoading";
import { useStyle } from "./style";
import { ELabelPriceVariant } from "./ELabelPriceVariant";

interface IParams {
    isLoading?: boolean;
    label: string;
    price: number;
    variant?: ELabelPriceVariant;
}

export const LabelPrice = (props: IParams) => {
    const { classes } = useStyle();
    const { t } = useTranslation(["common"]);

    const { label, price, variant = ELabelPriceVariant.ITEM, isLoading } = props;

    const variants = {
        [ELabelPriceVariant.ITEM]: {
            container: classes.flyingCartItemRow,
            label: classes.flyingCartItemLabel,
            price: classes.flyingCartItemPrice,
        },
        [ELabelPriceVariant.TOTAL]: {
            container: classes.flyingCartTotalRow,
            label: classes.flyingCartTotalLabel,
            price: classes.flyingCartTotalPrice,
        },
    } as const;

    const variantProp = variants[variant];

    return (
        <Box className={variantProp.container}>
            <Typography className={variantProp.label} variant={variant === ELabelPriceVariant.ITEM ? "small" : "large"}>
                {label}:
            </Typography>
            <HandleErrorAndLoading
                isLoading={isLoading ?? false}
                skeleton={<Skeleton className={`${variantProp.price} ${classes.priceSkeleton}`} variant="text" />}
            >
                <Typography
                    className={variantProp.price}
                    variant={variant === ELabelPriceVariant.ITEM ? "small" : "large"}
                >
                    {t("common:price", { price })}
                </Typography>
            </HandleErrorAndLoading>
        </Box>
    );
};
